import svg from 'src/images/custom-icons/royalties-operations.icon.svg';

const royaltiesOperationsSideBarTokens = {
    iconData: svg,
    iconWidth: 20,
    iconHeight: 20,
    iconTitle: 'Royalties Operations'
};

export default royaltiesOperationsSideBarTokens;
